import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import { ClearDiv } from '../../components/common';
import { AdminInviteEmail } from '../../components/pages/survey-admin/AdminInviteEmail';
import { AdminReminderEmail } from '../../components/pages/survey-admin/AdminReminderEmail';
import { AdminReopenSurvey } from '../../components/pages/survey-admin/AdminReopenSurvey';
import { AudienceAdminDetailsBasicPage } from '../../components/pages/survey-admin/audience/AudienceAdminDetailsBasicPage';
import { DistributionOptionsAdminPage } from '../../components/pages/survey-admin/audience/DistributionOptionsAdminPage';
import Constants from '../../constants';
import { AdminOpenClosePage } from '../../containers/pages/AdminOpenClosePage';
import { AdminAudienceMenuPage } from '../pages/AdminAudienceMenuPage';
import { AdminHierarchyViewPage } from '../pages/AdminHierarchyViewPage';
import { AdminParticipantsPage } from '../pages/AdminParticipantsPage';
import { AdminResetReopenResendPage } from '../pages/AdminResetReopenResendPage';
import { AudienceLoaderContainer } from '../pages/AudienceLoaderContainer';
import { ImportRetryPage } from '../pages/ImportRetryPage';
import { ParticipationMonitorPage } from '../pages/ParticipationMonitorPage';
import { SurveyAdminSummaryLoaderContainer } from '../pages/SurveyAdminSummaryLoaderContainer';
import { AudiencePageStateSetterRouteProps } from '../state-setter/AudiencePageStateSetterBase';
import { AdminLayoutContainer } from './AdminLayout';
import { BreadcrumbContainer } from './BreadcrumbContainer';
import { actionCreators } from './LayoutStore';

export class AdminAudienceRouter extends React.PureComponent<AudiencePageStateSetterRouteProps> {
	public render() {
		const surveyId = parseInt(this.props.match.params.surveyId, 10);
		const audienceId = parseInt(this.props.match.params.audienceId, 10);

		return (
			<>
				<SurveyAdminSummaryLoaderContainer surveyId={surveyId} {...this.props} />
				<AudienceLoaderContainer surveyId={surveyId} {...this.props} />
				<AdminLayoutContainer {...this.props} {...actionCreators} audienceId={audienceId}>
					<BreadcrumbContainer {...this.props} />
					<ClearDiv clearHeight={'30px'} />
					<Switch>
						<Route
							exact={true}
							path='/survey-admin/:surveyId/audience/:audienceId/invite-email'
							component={() => <AdminInviteEmail surveyId={surveyId} audienceId={audienceId} />}
						/>
						<Route
							exact={true}
							path='/survey-admin/:surveyId/audience/:audienceId/reminder-email'
							component={() => <AdminReminderEmail surveyId={surveyId} audienceId={audienceId} />}
						/>
						<Route
							exact={true}
							path='/survey-admin/:surveyId/audience/:audienceId/participation-monitor'
							component={() => <ParticipationMonitorPage surveyId={surveyId} audienceId={audienceId} />}
						/>
						<Route
							exact={true}
							path='/survey-admin/:surveyId/audience/:audienceId/participants'
							component={() => <AdminParticipantsPage surveyId={surveyId} audienceId={audienceId} />}
						/>
						<Route
							exact={true}
							path='/survey-admin/:surveyId/audience/:audienceId/hierarchy-view'
							component={() => <AdminHierarchyViewPage surveyId={surveyId} audienceId={audienceId} />}
						/>
						<Route
							exact={true}
							path={'/survey-admin/:surveyId/audience/:audienceId/' + Constants.SUBROUTE_SURVEY_ADMIN_RESET_REOPEN_RESEND}
							component={() => <AdminResetReopenResendPage surveyId={surveyId} audienceId={audienceId} />}
						/>
						<Route
							exact={true}
							path='/survey-admin/:surveyId/audience/:audienceId/import-retry'
							component={() => <ImportRetryPage surveyId={surveyId} />}
						/>
						<Route
							exact={true}
							path='/survey-admin/:surveyId/audience/:audienceId/open-close'
							component={() => <AdminOpenClosePage surveyId={surveyId} audienceId={audienceId} />}
						/>
						<Route exact={true} path='/survey-admin/:surveyId/audience/details/:audienceId?' component={AudienceAdminDetailsBasicPage} />
						<Route
							exact={true}
							path='/survey-admin/:surveyId/audience/:audienceId/distribution-options'
							component={DistributionOptionsAdminPage}
						/>
						<Route
							exact={true}
							path='/survey-admin/:surveyId/audience/:audienceId'
							component={() => <AdminAudienceMenuPage surveyId={surveyId} audienceId={audienceId} />}
						/>
						<Route
							exact={true}
							path='/survey-admin/:surveyId/audience/:audienceId/survey-reopen'
							component={() => <AdminReopenSurvey audienceId={audienceId} isUpdatingAtSurveyLevel={false} />}
						/>
					</Switch>
				</AdminLayoutContainer>
			</>
		);
	}
}
